import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapMutations } = createNamespacedHelpers('bis/authorize')

export default {
  computed: {
    ...mapState({
      $$user: 'user',
      $$terminal: 'terminal',
      $$app: 'app'
    }),
    ...mapGetters({
      $$configBis: 'configModel'
    })
  },
  async created () {
    // await this.$$loadConfig()
  },
  methods: {
    ...mapMutations({
      $$expireLogin: 'expire',
      $$logout: 'logout'
    })
    // ...mapActions({
    //   $$loadConfig: 'loadConfig'
    // })
  }
}
